import { useDeepCompareMemo } from 'use-deep-compare';
import { useLocation, useHref, useParams } from 'react-router';
import * as qs from "qs";

/**
 * HOC to provide the current version of react router's API in the format
 * of previous versions
 */
const withRouting = (Component) => (props) => {
  const location = useLocation();
  const params = useParams();
  const basename = useHref("/")
  const paramlessPath = Object.values(params).reduce(
        (path, param) => path.replace('/' + param, ''),
        location.pathname,
    ).replace("/", "");

  const router = useDeepCompareMemo(() => ({
    location: {
      pathname: location.pathname,
      query: qs.parse(location.search.replace('\?', '')),
      basename,
    },
    params,
    paramlessPath,
  }), [location.pathname, location.search, params, basename]);

  return (
    <Component {...props}  router={router} />
  )
}

export default withRouting;